import React from 'react';
import { List, Card, CardContent, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { uuid } from 'uuidv4';

export const DropSignatures = ({ steps, loadingSignatures, setIsDragging }) => {
  const { t } = useTranslation();

  const EachSignatures = ({ step }) => {
    step.signaturePositionId = uuid();

    const onDragStart = (event, stepType) => {
      event.dataTransfer.setData('application/customFlow', stepType);
      event.dataTransfer.effectAllowed = 'move';
    };

    return (
      <Card
        draggable={!loadingSignatures}
        onDrag={() => setIsDragging(true)}
        onDragStart={(event) => onDragStart(event, `${step.step.type}`)}
        style={{
          width: '100%',
          marginTop: '10px',
          height: (window.visualViewport.height - (15 * steps.length) - 100) / steps.length,
          marginBottom: '15px',
          borderRadius: '15px',
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'all-scroll',
          maxHeight: '125px'
        }}>
        <CardContent style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
          }}>
            <Typography style={{ color: 'black', width: '100%' }} component='h4' variant='h5'>
              {t(`customFlow:steps:${step.step.type}`)}
            </Typography>
          </div>
        </CardContent>
      </Card>
    );
  };

  return (

    <List>
      {steps.map((step, index) => {
        return (
          <EachSignatures step={step} key={index} />
        );
      })}
    </List>

  );
};
